import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../../config/Config";
import { getApiCall } from "../../ApiHelper";
import { RootState } from "../store";

type InitialState = {
    tabs: string[] | null,
    error: string,
    loading: boolean
}

const initialState: InitialState = {
    tabs: null,
    error: '',
    loading: false
}

let cacheKey: string | undefined = "";
export const getTabs = createAsyncThunk<string[],string|undefined, { state: RootState }>("getTabs", async (payload: string | undefined, { getState, rejectWithValue }) => {
    const state = getState().dashboardTab;
  
    if (state.tabs!=null && cacheKey !== "") {
      // Return the current data if it exists in the state and cacheKey is set
      return state.tabs;
    }
    if (state.tabs===null && cacheKey === payload) {
      // Return an empty array if there is no data in both the state and the cache
      return {} as string[];
    }
    try {
        var url = `${baseUrl}Dashboard/dashboardViews`;
        const response = await getApiCall<string[]>(url);
        cacheKey = payload;
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})`||error.message);
    }
})

const dashboardTabsSlice = createSlice({
    name: 'dashboardTabs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
            builder.addCase(getTabs.pending, (state) => {
                state.loading = true;
            })
            .addCase(getTabs.fulfilled, (state, action: PayloadAction<string[] | null>) => {
                state.loading = false;
                state.tabs = action.payload;
            })
            .addCase(getTabs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    }
});

export const getDashboardTabs = (state:any) => state.dashboardTabs.tabs

export default dashboardTabsSlice.reducer;
